<div>
  <form #salaryForm="ngForm" novalidate="novalidate" autocomplete="off">

    <div *ngIf="currentReport?.LATEST?.OWNERSHIP_LIST">
      <div class="row mb-4">
        <div class="col-lg-9 col-md-8">
          <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
            Owner's Compensation must be added back to the net income for the Company to realized the true cashflow to the Owner. Additionally, the fair market salary for a manager that would replace the current owner must be calculated and deducted in the adjustments.
          </div>
        </div>
        <div class="col-lg-3 col-md-4">
          <button id="edit-ownership-button" class="button secondary__button large__button half-rounded__button"
                  (click)="gotoOwnership()" [disabled]="currentReport?.isLocked">
            Edit Ownership
          </button>
        </div>

        <div class="col-md-12 color-secondary-gray font-size-14 font-weight-normal">
          Please enter the fair market salary that a hypothetical buyer would be required to
          pay for an outside
          hire to perform the same duties as this owner.
        </div>
      </div>

      <ng-container *ngFor="let ol of ownerList; let i = index">
        <div class="row mb-4 pb-2 gray-border-bottom" *ngIf="ol.HOURS > 0">
            <div class="col-md-12 align-self-center font-size-18 font-weight-bold">
              {{reportService.checkStringWithTrim(ol.DISPLAY_NAME) ? ol.DISPLAY_NAME : ol.NAME}} - This owner works about {{ol.HOURS}} hours per week.
            </div>

            <div class="col-md-12 form-inline">

              <div class="col-md-7 mobile-spacing-handling">
                What is the annual fair market replacement salary for {{reportService.checkStringWithTrim(ol.DISPLAY_NAME) ? ol.DISPLAY_NAME : ol.NAME}}?
              </div>

              <div class="col-md-5 pr-0 mobile-spacing-handling-input">

                <div
                  [ngClass]="{'input__error': (REPLACEMENT_SALARY.errors && (REPLACEMENT_SALARY.dirty || REPLACEMENT_SALARY.touched))}">

                  <number-input [(ngModel)]="ol.REPLACEMENT_SALARY"
                    [classes]="'input input__large input__blue'"
                    #REPLACEMENT_SALARY="ngModel"
                    [required]="true"
                    name="REPLACEMENT_SALARY_{{i}}"
                    (blur)="callUpdateAPI('REPLACEMENT_SALARY', ol)"
                    [disabled]="currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY != false || currentReport?.isLocked"
                    [allowZero]="true"
                    [clearZero]="false"
                    id="REPLACEMENT_SALARY_{{i}}"></number-input>

                </div>

              </div>

              <div class="col-md-12 text-right" *ngIf="currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY != false && !ol.REPLACEMENT_SALARY">
                <small class="color--light--gray">Based on total hours worked, {{reportService.checkStringWithTrim(ol.DISPLAY_NAME) ? ol.DISPLAY_NAME : ol.NAME}} does not require a replacement salary.</small>
              </div>

              <div class="col-md-12 handle-mobile-alignment" *ngIf="currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY != false">
                <small class="color--light--gray">This has been automatically calculated based on market and industry data.<br>You can manually edit this by clicking “Manual Overrides” below.</small>
              </div>

            </div>
        </div>
      </ng-container>

      <div class="row mb-4">
        <div class="col-md-12 mb-3">
          <button id="replacement-salary-calulation-btn" class="button primary__button half-rounded__button mr-3"
            (click)="calculateButtonClick('ASSISTED_REPLACEMENT_SALARY')"
            [disabled]="currentReport?.isLocked">
            {{currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY != false ? 'Manual Overrides' : 'Help me Calculate'}}
          </button>
        </div>

        <div class="col-md-12">

          <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
            For assistance in finding a fair market salary, please visit next resources:<br />
            <a id="replacement-salary-resources-indeed" href="https://www.indeed.com/salaries" target="_blank" rel="noopener">indeed.com/salaries</a><br/>
            <a id="replacement-salary-resources-simplyhired" href="http://simplyhired.com/salaries" target="_blank" rel="noopener">simplyhired.com/salaries</a><br/>
            <a id="replacement-salary-resources-glassdoor" href="https://www.glassdoor.com/Salaries/index.htm" target="_blank" rel="noopener">glassdoor.com/salaries</a>
          </div>
        </div>
      </div>

    </div>

  </form>
</div>
<report-footer [nextBtnEnable]="!salaryForm.invalid || currentReport?.isLocked"
  (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.OWNERS_SALARY">
</report-footer>
